module.exports = __webpack_public_path__ + "static/media/39_A.bef6cc3f.png";